import { FormControl, FormLabel, Input } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { usePaymentStore } from "../../../payment";

const _t = (key: string) => key;

const CheckoutReferralCode = ({
  onChange: onChange,
}: {
  onChange: (value: string) => void;
}) => {
  const discount = usePaymentStore((state) => state.discount);

  const { register, getValues, setValue, watch } = useForm<{
    referralCode: string;
  }>({
    defaultValues: {
      referralCode: discount?.isReferral ? discount.code : "",
    },
  });

  useEffect(() => {
    if (!discount?.isReferral) return;
    setValue("referralCode", discount.code);
  }, [discount?.isReferral]);

  useEffect(() => {
    const subscription = watch(async () => {
      onChange(getValues().referralCode);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <div className="flex flex-row items-center p-2">
      <FormControl isReadOnly={!!(discount && discount.isReferral)}>
        <FormLabel
          htmlFor="referralCode"
          minH={6}
          display="flex"
          alignItems="center"
        >
          Referral Code
        </FormLabel>
        <Input
          type="text"
          placeholder="Enter Referral Code (if any)"
          {...register("referralCode")}
        />
      </FormControl>
    </div>
  );
};

export default CheckoutReferralCode;
